import React, { Component } from 'react'
import PropTypes from 'prop-types'
import FilterDateRangeV2 from '../../home/components/filters/FilterDateRangeV2'
import FilterProductType from './FilterProductType'
import { Input, Select } from 'antd'
import SearchField from '../../home/components/filters/SearchField'
import { TAGS } from '../../batchesV3/components/filters/listOptions.json'
import FilterUserCut from './FilterUserCut'

const { Search } = Input
const { Option } = Select
class FilterLazeCutting extends Component {

    _handleChangeName = (value) => {
        const { handleChangeInput } = this.props

        if (typeof handleChangeInput === 'function') {
            handleChangeInput('name', value)
        }
    }

    _handleChange = e => {
        const { value } = e.target

        if (this._timeOut) clearTimeout(this._timeOut)

        this._timeOut = setTimeout(() => {
            this._handleChangeName(value)
        }, 500)
    }

    _handleChangeDate = (field, value) => {
        const { handleChangeDate, dateValue } = this.props
        const cloneFilter = Object.assign({}, dateValue[field])

        cloneFilter[field] = value

        if (value.from === '' || value.to === '') {
            delete cloneFilter[field]
        }

        handleChangeDate(field, cloneFilter)
    }


    render() {
        const { productTypes, onChangeProductType, usersCut, onChangeUsersCut, receivedUsers, onChangeReceivedUsers, handleChangeInput, handleChangeSelect, userCreate, tags = [] } = this.props

        return (
            <div className='BatchesPageContainer'>
                <div className='row align-items-start'>
                    <div className='FilterNameBatch col-12 col-xl-2 mb-3'>
                        <label className="d-block w-100 font-weight-bold mb-1">Tên lô</label>
                        <div className='SearchField'>
                            <Search placeholder='Tìm kiếm theo tên Lô...' onChange={this._handleChange} allowClear={true} />
                        </div>
                    </div>
                    <div className='col-12 col-xl-2 mb-3'>
                        <label className="d-block w-100 font-weight-bold mb-1">Ngày cắt</label>
                        <FilterDateRangeV2 field='created_at' onDatesChange={this._handleChangeDate} showTime={true} />
                    </div>


                    <div className='col-12 col-xl-4 mb-3'>
                        <label className="d-block w-100 font-weight-bold mb-1">Loại sản phẩm</label>
                        <FilterProductType
                            productTypes={productTypes}
                            onChangeProductType={onChangeProductType}
                        />
                    </div>

                    <div className='col-12 col-xl-2 mb-3'>
                        <label className="d-block w-100 font-weight-bold mb-1">Người cắt</label>
                        <FilterUserCut
                            usersCut={usersCut}
                            onChangeUsersCut={onChangeUsersCut}
                            placeholder='Chọn người cắt'
                        />
                    </div>
                    <div className='col-12 col-xl-2 mb-3'>
                        <label className="d-block w-100 font-weight-bold mb-1">Người nhận cắt</label>
                        <FilterUserCut
                            usersCut={receivedUsers}
                            onChangeUsersCut={onChangeReceivedUsers}
                            placeholder='Chọn người nhận cắt'
                        />
                    </div>
                    <div className='col-12 col-xl-2 mb-3'>
                        <label className="font-weight-bold d-block mb-1">Người tạo lô</label>
                        <SearchField
                            field='user_create'
                            placeholder='Tìm kiếm theo người tạo ...'
                            onChangeInput={handleChangeInput}
                        />
                    </div>
                    <div className='col-12 col-xl-2 mb-3'>
                        <label className="d-block w-100 font-weight-bold mb-1">Tags</label>
                        <Select
                            value={tags || []}
                            mode="tags"
                            style={{ width: '100%' }}
                            placeholder='Chọn tag'
                            allowClear
                            filterOption={(input, option) =>
                                option.props.children.toString().toLowerCase().indexOf(input.toString().toLowerCase()) >= 0
                            }
                            onChange={(value) => handleChangeSelect('tags', value)}
                        >
                            {Array.isArray(TAGS) && TAGS.length > 0 &&
                                TAGS.map((item, index) =>
                                    <Option key={index} value={item.value}>
                                        {item.name}
                                    </Option>
                                )
                            }
                        </Select>
                    </div>

                    <div className='col-12 col-xl-2 mb-3'>
                        <label className="d-block w-100 font-weight-bold mb-1">Ngày nhận lô cut laze</label>
                        <FilterDateRangeV2 field='receivedLaserAt' onDatesChange={this._handleChangeDate} showTime={false} />
                    </div>
                </div>
            </div>
        )
    }

}

FilterLazeCutting.defaultProps = {
    showPartner: true
}

FilterLazeCutting.propTypes = {
    loading: PropTypes.bool,
    onChangeProductType: PropTypes.func.isRequired,
    onChangeUsersCut: PropTypes.func.isRequired,
    onChangeReceivedUsers: PropTypes.func.isRequired,
    handleChangeDate: PropTypes.func.isRequired,
    handleChangeInput: PropTypes.func.isRequired,
}

export default FilterLazeCutting
